import { Card, Button, message } from "antd";
import { useState, useEffect } from "react";

const MAX_STEP_LENGTH = 2000;

function pickAr(overlay) {
  return typeof overlay?.ar === "string" ? overlay.ar : "";
}

export default function DirectionsBuilder({ setSteps, initialSteps = [] }) {
  const [stepsData, setStepsData] = useState([
    { id: "init-0", description: "", descriptionAr: "" },
  ]);

  useEffect(() => {
    if (initialSteps?.length) {
      const mapped = initialSteps.map((s, index) => ({
        id: `init-${index}`,
        description: s.description || "",
        descriptionAr: pickAr(s.descriptionI18n) || s.descriptionAr || "",
      }));
      setStepsData(mapped);
    }
  }, [initialSteps]);

  useEffect(() => {
    const formatted = stepsData
      .filter((s) => s.description.trim() !== "")
      .map((s, index) => {
        const next = {
          stepNumber: index + 1,
          description: s.description.trim(),
        };
        const ar = (s.descriptionAr || "").trim();
        if (ar) next.descriptionI18n = { ar };
        return next;
      });

    setSteps(formatted);
  }, [stepsData, setSteps]);

  const handleAddStep = () => {
    setStepsData([
      ...stepsData,
      { id: `new-${Date.now()}`, description: "", descriptionAr: "" },
    ]);
  };

  const handleDeleteStep = (id) => {
    if (stepsData.length === 1) return;

    const updated = stepsData.filter((s) => s.id !== id);
    setStepsData(updated);
  };

  const handleChange = (id, field, value, event) => {
    if (value.length > MAX_STEP_LENGTH) {
      message.warning("Step description too long (max 2000 characters)");
      return;
    }

    const el = event?.target;

    if (el) {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    }

    const updated = stepsData.map((s) =>
      s.id === id ? { ...s, [field]: value } : s
    );
    setStepsData(updated);
  };

  return (
    <Card className="recipe-section">
      <div className="section-title">
        <span className="section-bar" />
        <h3>4. Directions</h3>
      </div>

      {stepsData.map((step, index) => (
        <div className="step-block" key={step.id}>
          <div className="step-title">Step {index + 1}</div>

          <textarea
            className="directions-textarea"
            value={step.description}
            onChange={(e) =>
              handleChange(step.id, "description", e.target.value, e)
            }
            placeholder="Sauté onion and garlic with cumin until soft."
            rows={6}
          />

          <div className="step-title" style={{ marginTop: 12 }}>
            Step {index + 1} (Arabic)
          </div>

          <textarea
            className="directions-textarea"
            value={step.descriptionAr}
            onChange={(e) =>
              handleChange(step.id, "descriptionAr", e.target.value, e)
            }
            placeholder="اقلي البصل والثوم مع الكمون حتى يلين."
            dir="rtl"
            rows={6}
          />

          <Button
            danger
            className="delete-step-btn"
            onClick={() => handleDeleteStep(step.id)}
            disabled={stepsData.length === 1}
          >
            Delete Item
          </Button>
        </div>
      ))}

      <div className="add-step-link" onClick={handleAddStep}>
        + Add Step
      </div>
    </Card>
  );
}
